/* ADD SOFTSKILL ABILITY */
export const ADD_SOFTSKILL_ABILITY = "ADD_SOFTSKILL_ABILITY"
export const ADD_SOFTSKILL_ABILITY_SUCCESS = "ADD_SOFTSKILL_ABILITY_SUCCESS"
export const ADD_SOFTSKILL_ABILITY_CLEAN = "ADD_SOFTSKILL_ABILITY_CLEAN"
export const ADD_SOFTSKILL_ABILITY_ERROR = "ADD_SOFTSKILL_ABILITY_ERROR"
